module.exports = __webpack_public_path__ + "img/fire.34cffd55.svg";